/**
 * 创建一个函数，该函数只会在第一次调用时执行给定的回调函数，并缓存结果。
 * 后续的调用将返回第一次调用时缓存的结果。
 * 
 * @param callback 要在第一次调用时执行的回调函数，如果不需要执行回调，可以传入null。
 * @param t 执行回调函数时使用的this对象，如果未提供，则使用外部this（或undefined，如果没有this上下文）。
 * @returns 返回一个新的函数，该函数将在第一次调用时执行callback，并在后续调用中返回第一次调用的结果。
 */
export const once = (callback: Function | null, t?: any) => {
  let func: Function;
  return function () {
    if (callback) {
      // 忽略typescript的错误，允许callback被调用并赋值给func
      // @ts-ignore: 2683
      func = callback.apply(t || this, arguments);
      callback = null;
      return func;
    }
  }
}